import React, { useState, useEffect } from 'react';
import { getCookie, setCookie } from '../../utils/cookies';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = getCookie('cookieConsent');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    setCookie('cookieConsent', 'accepted', 365);
    setIsVisible(false);
  };

  const handleDecline = () => {
    setCookie('cookieConsent', 'declined', 365);
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: 'rgb(14, 13, 13)',
        borderTop: '2px solid #c584f3',
        padding: '20px',
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '15px',
        boxShadow: '0 -4px 20px rgba(128, 92, 243, 0.3)'
      }}
    >
      <p style={{ 
        color: 'white', 
        textAlign: 'center',
        margin: 0,
        fontSize: '16px',
        maxWidth: '800px'
      }}>
        This website uses cookies to enhance your experience. By continuing to visit this site you agree to our use of cookies.
      </p>
      <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap', justifyContent: 'center' }}>
        <button
          onClick={handleAccept}
          style={{
            background: 'linear-gradient(to bottom, #dfbbfb, #6b21a8)',
            border: '1px solid #c584f3',
            borderRadius: '6px',
            color: 'white',
            padding: '10px 25px',
            fontSize: '15px',
            fontWeight: 'bold',
            cursor: 'pointer',
            boxShadow: 'inset 0px 1px 0px 0px #efdcfb',
            transition: 'opacity 0.2s'
          }}
          onMouseOver={(e) => e.target.style.opacity = 0.9}
          onMouseOut={(e) => e.target.style.opacity = 1}
        >
          Accept
        </button>
        <button
          onClick={handleDecline}
          style={{
            background: 'transparent',
            border: '1px solid #666',
            borderRadius: '6px',
            color: '#aaa',
            padding: '10px 25px',
            fontSize: '15px',
            fontWeight: 'bold',
            cursor: 'pointer',
            transition: 'opacity 0.2s'
          }}
          onMouseOver={(e) => e.target.style.opacity = 0.7}
          onMouseOut={(e) => e.target.style.opacity = 1}
        >
          Decline
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
